import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {requestSaveJobPipeline} from "@app/services/JobPipelineService";
import {alertMessage, Messages} from "@app/constants/Messages";
import {pipelineOptionsToString, pipelineStringToOptions} from "@pages/jobpipeline/common/PipelineUtil";
import RunJobParentTabContent from "@pages/job/runjob/RunJobParentTabContent";
import RunJobBasicInfo from "@pages/job/runjob/RunJobBasicInfo";
import {MailTempType} from "@pages/email/common/Constant";
import UpdateFullMailTemplateModal from "@pages/email/template/edit/UpdateFullMailTemplateModal";
import RunJobDetailInfo from "@pages/job/runjob/RunJobDetailInfo";
import {requestStartRunJob} from "@app/services/JobService";
import SearchUVRunJobPipelineModal from "@pages/job/runjob/SearchUVRunJobPipelineModal";
import CompareCandidatesFromExcelModal from "@pages/job/runjob/CompareCandidatesFromExcelModal";
import CopyPipelinesModal from "@pages/job/runjob/CopyPipelinesModal";

const RunJobMainModal = (props) => {
    const [runJobMainData, setRunJobMainData] = useState({
        run_job_id: '',
        invite_mail_template_id: '',
        job_id: '',
        candidate_ids: [],
        invite_mail_template: {},
        email_tab: {

        }
    });
    const [showEditFullMailTempModal, setShowEditFullMailTempModal] = useState(false)
    const [showSearchUVRunJobPipelines, setShowSearchUVRunJobPipelines] = useState(false)
    const [showCompareCandidates, setShowCompareCandidates] = useState(false)
    const [copyPipelines, setCopyPipelines] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {candidateIds, jobId, isShow, onClose} = props

    const onStartRunJob = (runJobData) => {
        if (!runJobData.invite_mail_template) {
            alert(Messages.requireSetJobFullTemplate)
            setShowEditFullMailTempModal(true)
        }
        setRunJobMainData(runJobData)
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])


    useEffect(() => {
        if (candidateIds) {
            runJobMainData.candidate_ids = candidateIds
            setRunJobMainData({...runJobMainData})
        }
    }, [candidateIds]);

    useEffect(() => {
        if (jobId) {
            requestStartRunJob({candidate_ids: candidateIds, job_id: jobId}).then(res => {
                setRunJobMainData(res.content)
                onStartRunJob(res.content)
            })
        }
    }, [jobId]);

    const onCloseUpdateFullMailTemplate = (temp) => {
        runJobMainData.invite_mail_template = temp
        setShowEditFullMailTempModal(false)
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Run Job'}
                    </Modal.Title>
                    <div className={"row"}>
                        {runJobMainData.id &&
                            <>
                                <Button variant='success mr-3' onClick={() => setShowCompareCandidates(true)}>
                                    Nhúng list excel
                                </Button>
                                <Button variant='info mr-3' onClick={() => setShowEditFullMailTempModal(true)}>
                                    Email template
                                </Button>
                                <Button variant='primary mr-3' onClick={() => setShowSearchUVRunJobPipelines(true)}>
                                    Search UV
                                </Button>
                                <Button variant='warning mr-3' onClick={() => setCopyPipelines(true)}>
                                    Copy list from job tương tự
                                </Button>
                            </>
                        }
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <RunJobBasicInfo runJob={runJobMainData} onStart={(runJobData) => onStartRunJob(runJobData)}/>
                    {runJobMainData.id &&
                    <RunJobDetailInfo runJob={runJobMainData}/>
                    }
                </Modal.Body>
            </Modal>
            {showEditFullMailTempModal &&
            <UpdateFullMailTemplateModal isShow={showEditFullMailTempModal}
                                         template={runJobMainData.invite_mail_template}
                                         onClose={(temp) => onCloseUpdateFullMailTemplate(temp)}
            />
            }
            {showSearchUVRunJobPipelines &&
            <SearchUVRunJobPipelineModal isShow={showSearchUVRunJobPipelines}
                                         runJob={runJobMainData}
                                         onClose={() => setShowSearchUVRunJobPipelines(false)}
            />
            }
            {showCompareCandidates &&
            <CompareCandidatesFromExcelModal isShow={showCompareCandidates}
                                         runJob={runJobMainData}
                                         onClose={() => setShowCompareCandidates(false)}
            />
            }
            {copyPipelines &&
            <CopyPipelinesModal isShow={copyPipelines}
                                currentJobId={runJobMainData.job_id}
                                onClose={() => setCopyPipelines(false)}
            />
            }
        </>
    )
}

export default RunJobMainModal;
